import { entities } from './TimelineEntities';

class TimelineFiltersLoader {
    constructor(linkedtype) {
        this.linkedtype = linkedtype;
    }

    load() {
        //get grouped filters in mapping file
        const mappingName = this.linkedtype.substr(0, 1).toUpperCase() + this.linkedtype.substr(1);
        const { entitiesGroups } = require(`../overview/tabs/mapping/${mappingName}Mapping`);
        const allEntities = entities;

        return new Promise((resolve, reject) => {
            // fetch custom event types filters
            ApiClient.get('custom-activity-types').then((result) => {
                const index = entitiesGroups.findIndex((item) => item.value === 'customactivity');
                if (index !== -1) {
                    entitiesGroups.splice(index, 1);
                }

                const customActivityFilters = {
                    label: window.i18n.__('Activités personnalisées'),
                    value: 'customactivity',
                    entities: [],
                };

                if (result.data && result.data.data) {
                    result.data.data.forEach((customActivityType) => {
                        //add custom event types in grouped filters
                        const filterValue = `customactivity_${customActivityType.id}`;
                        customActivityFilters.entities.push(filterValue);
                        //add custom event types in entities list
                        allEntities.push({
                            value: filterValue,
                            label: customActivityType.name,
                            checked: false,
                        });
                    });

                    entitiesGroups.push(customActivityFilters);

                    resolve({
                        entitiesGroups: entitiesGroups,
                        entities: allEntities,
                    });
                } else {
                    reject();
                }
            }, reject);
        });
    }
}

export default TimelineFiltersLoader;
